var stageDevices = {
    list: function(page){
        var params = utils.getParamObj();
        params.like = $("#like").val();
        params.page = page || 1;

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);

            $.get(getParams,params,function(resp){
                $("#zone_devices_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    save: function(deviceID){
        var params = $("form#devicesForm :input").serializeObj();
        params._token = utils.getToken();

        $.post('/stages/devices/save/' + deviceID, params, function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
};